import React from "react";
import PropTypes from "prop-types";
import { Modal } from "MODULES/shared/components/Modal";
import { Body, Header, Footer } from "../MarkAllRead";

export default function ConfirmModal({ open, close, onConfirm, prompt }) {
  return (
    <Modal open={open} close={close} dialogClass="modal-sm">
      <Header close={close} />
      <Body prompt={prompt} />
      <Footer close={close} onConfirm={onConfirm} />
    </Modal>
  );
}

ConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  prompt: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/Notifications/components/Search/MarkAllRead/ConfirmModal.jsx